import {remote} from '../constants/environment';
import {defaultHeaders} from './headers';
import {customFetch as fetch, remoteCall} from '../utils/services';
import {ISalesmanResourceResponse} from '../interfaces/services/salesman-resources.interface';

export const getSalesmanResources = async (
  token: string,
): Promise<ISalesmanResourceResponse> => {
  const remoteURI = remote.getSalesmanResourcesUri();
  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'GET',
        headers: {
          ...defaultHeaders,
          'token-session': token,
        },
      });
    },
    async (response: Response) => {
      if (response.status === 200) {
        const data = await response.json();

        if (data.success && data.payload) {
          const success = true;
          return {
            success,
            payload: data.payload,
          };
        } else {
          return {
            success: false,
            payload: null,
          };
        }
      }
    },
    remoteURI,
  )) as ISalesmanResourceResponse;
};
